module.exports = __webpack_public_path__ + "static/media/3.2728e884.jpg";